export default function tokenReducer(token, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "postToken":
      return { ...token, ...action.value };

    default:
      return { ...token, [action.type]: action.value };
  }
}
